import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { ProfileUpdateRequest } from "hooks/useProfile";
import {
  SectionTitle,
  EditFormGrid,
  FormField,
  FormLabel,
  FormActions,
} from "styles/components/userDetails.styles";

interface Props {
  form: ProfileUpdateRequest;
  isSaving: boolean;
  onChange: (updated: ProfileUpdateRequest) => void;
  onSave: () => void;
}

function ProfileEditTab({ form, isSaving, onChange, onSave }: Props) {
  const set = (patch: Partial<ProfileUpdateRequest>) =>
    onChange({ ...form, ...patch });

  return (
    <div style={{ marginTop: "1rem" }}>
      <SectionTitle>
        <i className="pi pi-user-edit" />
        Edit Profile
      </SectionTitle>

      <EditFormGrid>
        <FormField>
          <FormLabel htmlFor="profile-firstName">First Name</FormLabel>
          <InputText
            id="profile-firstName"
            value={form.firstName ?? ""}
            onChange={(e) => set({ firstName: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="profile-lastName">Last Name</FormLabel>
          <InputText
            id="profile-lastName"
            value={form.lastName ?? ""}
            onChange={(e) => set({ lastName: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="profile-email">Email</FormLabel>
          <InputText
            id="profile-email"
            type="email"
            value={form.email ?? ""}
            onChange={(e) => set({ email: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="profile-phone">Phone</FormLabel>
          <InputText
            id="profile-phone"
            value={form.phone ?? ""}
            onChange={(e) => set({ phone: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="profile-city">City</FormLabel>
          <InputText
            id="profile-city"
            value={form.city ?? ""}
            onChange={(e) => set({ city: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="profile-country">Country</FormLabel>
          <InputText
            id="profile-country"
            value={form.country ?? ""}
            onChange={(e) => set({ country: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="profile-language">Language</FormLabel>
          <InputText
            id="profile-language"
            value={form.language ?? ""}
            onChange={(e) => set({ language: e.target.value })}
          />
        </FormField>
      </EditFormGrid>

      <FormActions>
        <Button
          label="Save Changes"
          icon="pi pi-save"
          onClick={onSave}
          loading={isSaving}
        />
      </FormActions>
    </div>
  );
}

export default ProfileEditTab;
